import React, { FC, useState } from 'react';
import { useToggle } from 'react-use';
import { Icon } from '@app/components/Icon';
import { Button } from '@chakra-ui/react';
import { RemoveLiquidityModalV3Content } from '@app/screens/positions/components/RemoveLiquidityModalV3/RemoveLiquidityModalV3Content';
import { useRouter } from 'next/router';
import { TransactionResultModal } from '@app/components/TransactionResultModal';

interface Props {
  positionId: number;
  fullWidth?: boolean;
}

export const RemoveLiquidityModalV3: FC<Props> = ({
  positionId,
  fullWidth
}) => {
  const router = useRouter();
  const [feedback, setFeedback] = useState<{
    status: 'success' | 'error';
    title: string;
    message: string;
    txHash?: string;
  } | null>(null);
  const [open, toggleOpen] = useToggle(false);

  return (
    <>
      <Button
        width={fullWidth ? '100%' : ['100%', 'fit-content']}
        leftIcon={
          <Icon name="minusCircle" style={{ width: '18px', height: '18px' }} />
        }
        variant="rowCompact"
        onClick={toggleOpen}
      >
        Withdraw
      </Button>
      {open && (
        <RemoveLiquidityModalV3Content
          onClose={(txHash?: string) => {
            if (txHash) {
              setFeedback({
                status: 'success',
                title: 'Transaction Confirmed',
                message: 'Your transaction has been successfully completed',
                txHash
              });
            } else {
              toggleOpen(false);
            }
          }}
          isOpen={open}
          positionId={positionId}
        />
      )}
      <TransactionResultModal
        isOpen={!!feedback}
        status={feedback?.status}
        title={feedback?.title}
        message={feedback?.message}
        txHash={feedback?.txHash}
        onClose={() => {
          setFeedback(null);
          router.reload();
        }}
      />
    </>
  );
};
